import { render, staticRenderFns } from "./CertificationDetails.vue?vue&type=template&id=1b15a71a&scoped=true"
import script from "./CertificationDetails.vue?vue&type=script&lang=ts"
export * from "./CertificationDetails.vue?vue&type=script&lang=ts"
import style0 from "./CertificationDetails.vue?vue&type=style&index=0&id=1b15a71a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b15a71a",
  null
  
)

export default component.exports